import { render, staticRenderFns } from "./ChallengeStanding.vue?vue&type=template&id=7d9c113c&scoped=true&"
import script from "./ChallengeStanding.vue?vue&type=script&lang=js&"
export * from "./ChallengeStanding.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeStanding.vue?vue&type=style&index=0&id=7d9c113c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9c113c",
  null
  
)

export default component.exports